/**
 * 住宿预订：团队成员下拉（与 step2 member_table_list / member_options 一致）
 */

export function normalizeMemberOptionList(source) {
  if (!Array.isArray(source) || source.length === 0) {
    return [];
  }
  const first = source[0];
  if (first && first.value != null && first.value !== '') {
    const seen = new Set();
    return source
      .map((item) => {
        const value = (item.value != null ? String(item.value) : '').trim();
        if (!value || seen.has(value)) {
          return null;
        }
        seen.add(value);
        return {
          label: (item.label != null ? String(item.label) : value).trim() || value,
          value,
        };
      })
      .filter(Boolean);
  }
  const options = [];
  const seen = new Set();
  source.forEach((item) => {
    const name = (item && item.full_name != null ? String(item.full_name) : '').trim();
    if (!name || seen.has(name)) {
      return;
    }
    seen.add(name);
    options.push({ label: name, value: name });
  });
  return options;
}

/** 收集其他房间/槽位已选人员（当前槽位与同行另一槽位除外） */
export function collectExcludedMemberNames(bookingList, rowIndex, slot) {
  const used = new Set();
  const list = bookingList || [];
  const current = list[rowIndex] || {};
  list.forEach((row, idx) => {
    const n1 = (row.member1 || '').trim();
    const n2 = (row.member2 || '').trim();
    if (n1 && !(idx === rowIndex && slot === 'member1')) {
      used.add(n1);
    }
    if (n2 && !(idx === rowIndex && slot === 'member2')) {
      used.add(n2);
    }
  });
  if (slot === 'member1' && current.member2) {
    used.add(String(current.member2).trim());
  }
  if (slot === 'member2' && current.member1) {
    used.add(String(current.member1).trim());
  }
  return used;
}

export function filterMemberSelectOptions(teamOptions, excludedSet) {
  return (teamOptions || []).filter((opt) => !excludedSet.has(opt.value));
}



// WEBPACK FOOTER //
// ./src/utils/teamMemberSelect.js